module.exports = __webpack_public_path__ + "img/basic.1ab35df8.svg";